module.exports = __webpack_public_path__ + "media/images/icon/rocket-4df04878ea7501d452e6730eaf5adeff.svg";